import { render, staticRenderFns } from "./SalePricesRuleSelection.vue?vue&type=template&id=9c0c9dea&scoped=true"
import script from "./SalePricesRuleSelection.vue?vue&type=script&lang=js"
export * from "./SalePricesRuleSelection.vue?vue&type=script&lang=js"
import style0 from "./SalePricesRuleSelection.vue?vue&type=style&index=0&id=9c0c9dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0c9dea",
  null
  
)

export default component.exports